import React, { FC, useEffect, useMemo } from 'react';
import WiseSelect from 'components/wise/WiseSelect';
import { useLoadData } from 'plugins/api/endpoints/useLoadData';
import { IWiseTableQueryParams, IWiseTableParameter } from 'components/wise/types';

interface IWiseTableSelectProps {
  parameter: IWiseTableParameter;
  queryParams: IWiseTableQueryParams;
  updateParameter: (fieldSymbol: string, value: any) => void;
}

const WiseTableSelect: FC<IWiseTableSelectProps> = ({
  parameter,
  queryParams,
  updateParameter
}) => {
  const fieldSymbol = parameter.field_symbol || '';
  const currentValue = queryParams[fieldSymbol] || null;

  const { data: selectDataOptions, refetch: refetchSelectDataOptions } = useLoadData(
    parameter.dictionary?.values_get_u_i_api || '',
    { page: 1, limit: 999 },
    { enabled: false }
  );

  useEffect(() => {
    if (parameter.dictionary?.values_get_u_i_api) {
      refetchSelectDataOptions();
    }
  }, [parameter.dictionary?.values_get_u_i_api]);

  const options = useMemo(() => {
    return (
      selectDataOptions?.items?.map((value: any) => ({
        value: value.value,
        label: value.text,
        item: value
      })) ||
      parameter.dictionary?.values?.map((value) => ({
        value: value.value,
        label: value.text,
        item: value
      })) ||
      []
    );
  }, [selectDataOptions, parameter.dictionary]);

  return (
      <WiseSelect
        styleGroup="wise-table"
        placeholder={parameter.label}
        value={currentValue}
        options={options}
        clearable
        onChange={(item) => {
          updateParameter(fieldSymbol, item?.value || null);
        }}
      />
  );
};

export default WiseTableSelect;
